import { useMemo } from 'react'
import { useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId } from '@/api/generated/company-management-user/company-management-user'
import type {HealthInsuranceEmployeeConfigModel, InsuranceServiceModuleModel} from '@/api/model'

function unwrap<T>(data: unknown): T | undefined {
  return ((data as { data?: T })?.data ?? data) as T | undefined
}

export function useHealthInsuranceConfigs(serviceModuleId: number) {
  const query = useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId(serviceModuleId)

  const configsByEmployeeId = useMemo(() => {
    const module = unwrap<InsuranceServiceModuleModel>(query.data)
    const configs = module?.healthInsuranceEmployeeConfigs ?? []
    return new Map(
      configs
        .filter((c): c is HealthInsuranceEmployeeConfigModel & { employeeUserId: string } => c.employeeUserId != null)
        .map((c) => [c.employeeUserId, c])
    )
  }, [query.data])

  return {
    healthConfigsByEmployeeId: configsByEmployeeId,
    isLoading: query.isLoading,
    isError: query.isError,
    refetchHealthConfigs: query.refetch,
  }
}
